// extracted by mini-css-extract-plugin
export default {"rectangle":"addDialer_rectangle__lam5C","wrapper":"addDialer_wrapper__gVzOa","addButton":"addDialer_addButton__fCcm8"};